// main base/api URLS are pulled from .env files by nuxt.config.js and added to the global $config variable //

// user endpoints
const LOGIN_ROUTE = "login";
const LOGOUT_ROUTE = "logout";
const FORGOT_PASSWORD = "forgot-password";
const RESET_PASSWORD = "reset-password";
const REFRESH_ROUTE = "refresh";
const FETCH_ROUTE = "fetch";
const CHECK_ROUTE = "check";
const SIGNUP_ROUTE = "signup";
const ACTIVATION_ROUTE = "activate";
const ACCOUNT_UPDATE_ROUTE = "update";
const COUNTRIES_ROUTE = "countries";
// project endpoints
const SCHEDULE_ROUTE = "schedules"; // example not real

export default {
  // User
  LOGIN_ROUTE,
  LOGOUT_ROUTE,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  REFRESH_ROUTE,
  FETCH_ROUTE,
  CHECK_ROUTE,
  SIGNUP_ROUTE,
  ACTIVATION_ROUTE,
  ACCOUNT_UPDATE_ROUTE,
  // Project
  SCHEDULE_ROUTE,
  COUNTRIES_ROUTE
};
